export const ordHeaders = [
  {name: 'Order #', val: 0},
  {name: 'Customer Name', val: 1},
  {name: 'Items', val: 2},
  {name: 'Tracking #', val: 4},
  {name: 'Order Date', val: 5},
  {name: 'Total', val: 6},
  {name: 'Status', val: 7},
  {name: 'Actions', val: -1}
]

export const transHeaders = [
  {name: 'Transaction #', val: 0},
  {name: 'Order #', val: 1},
  {name: 'Customer Name', val: 2},
  {name: 'Card Number', val: 3},
  {name: 'Total', val: 4},
  {name: 'Date', val: 5},
  {name: 'Actions', val: -1}
]